// CREATE GIFT
export const CREATE_GIFT = 'CREATE_GIFT';
export const CREATE_GIFT_SUCCESS = 'CREATE_GIFT_SUCCESS';
export const CREATE_GIFT_FAILED = 'CREATE_GIFT_FAILED';

// GET GIFT DETAILS
export const GET_GIFT_DETAILS = 'GET_GIFT_DETAILS';
export const GET_GIFT_DETAILS_SUCCESS = 'GET_GIFT_DETAILS_SUCCESS';
export const GET_GIFT_DETAILS_FAILED = 'GET_GIFT_DETAILS_FAILED';

// UPDATE GIFT
export const UPDATE_GIFT = 'UPDATE_GIFT';
export const UPDATE_GIFT_SUCCESS = 'UPDATE_GIFT_SUCCESS';
export const UPDATE_GIFT_FAILED = 'UPDATE_GIFT_FAILED';

// DELETE GIFT
export const DELETE_GIFT = 'DELETE_GIFT';
export const DELETE_GIFT_SUCCESS = 'DELETE_GIFT_SUCCESS';
export const DELETE_GIFT_FAILED = 'DELETE_GIFT_FAILED';

// GET GIFTS
export const GET_GIFTS = 'GET_GIFTS';
export const GET_GIFTS_SUCCESS = 'GET_GIFTS_SUCCESS';
export const GET_GIFTS_FAILED = 'GET_GIFTS_FAILED';

// GET USER GIFTS
export const GET_USER_GIFTS = 'GET_USER_GIFTS';
export const GET_USER_GIFTS_SUCCESS = 'GET_USER_GIFTS_SUCCESS';
export const GET_USER_GIFTS_FAILED = 'GET_USER_GIFTS_FAILED';
